export default {
   COMPANIES:'Choose all that apply'
}